enum ActionTypes {
  LOGIN = '@auth/LOGIN',
  CHECK_TWO_FACTOR = '@auth/CHECK_TWO_FACTOR',
  LOGOUT = '@auth/LOGOUT',
  LOGGED_IN_USER = '@auth/LOGGED_IN_USER',
}

export default ActionTypes
